<nz-drawer
      [nzClosable]="true"
      [nzVisible]="visible"
      [nzPlacement]="placement"
      [nzTitle]="notificationTitle"
      (nzOnClose)="close()"
      [nzWrapClassName]="'notification'"
    >
      <ng-container *nzDrawerContent  >
        <div infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="9"
        (scrolled)="onScroll($event)"
        [scrollWindow]="false"
        style="max-height:90vh! important;overflow-y: auto;">
        <p  *ngIf="notifications && notifications?.length > 0" style="position:relative;width: 100%;height: 11px;overflow: visible;" > 
          <span style="position:absolute;top:2;right:20px; cursor:pointer;font-size:10px" (click)="clearAll()">  Clear All </span></p>
       <div *ngIf="notifications.length > 0"> 
        <div *ngFor="let notif of notifications" class="notification-item" [ngClass]="{'bg-danger': notif.type == 3,'bg-warning': notif.type == 2,'bg-normal': notif.type == 1}">
          <div *ngIf="notif.object_name == 'Task'">
            <p style="display:flex;justify-content: space-between;width:100%;align-items: top;">  <a [href]="getUrl(notif.task)" target="_blank" style="font-size:12px;width:70%;" >  {{notif.task_name}} </a>  <span style="float:right;display:block;font-size:10px;text-transform: capitalize;">  {{notif.value}} </span> </p>
            <p style="display:flex;justify-content: space-between;width:100%;align-items: center;font-size:12px">{{notif.service}} - {{notif.task_due_date | date :'short'}}  
              <button nz-button nzType="primary" [nzSize]="'small'"  (click)="markRead(!notif.is_read,notif.id)" style="font-size:10px">
                <span nz-icon nzType="read"></span> {{notif.is_read ? 'Unread' : 'Read'}} 
              </button>
            </p>
          </div>
          <div *ngIf="notif.object_name == 'Domain'">
            <p style="display:flex;justify-content: space-between;width:100%;align-items: top;">  <span style="font-size:12px;width:40%;" >  {{notif.domain_name}} </span>  <span style="float:right;display:block;font-size:10px;text-transform: capitalize;">  {{notif.service}} </span> </p>
            <p style="display:flex;justify-content: space-between;width:100%;align-items: center;font-size:12px"> {{notif.value}}  
              <button nz-button nzType="primary" [nzSize]="'small'"  (click)="markRead(!notif.is_read,notif.id)" style="font-size:10px">
                <span nz-icon nzType="read"></span> {{notif.is_read ? 'Unread' : 'Read'}} 
              </button>
            </p>
          </div>
        </div>
      </div>
      <p style="text-align:center;font-weight:500;padding:20px;border:2px dashed lightblue;background: #f5f3f3;" *ngIf="notifications && notifications?.length == 0"> You have read all notifications. </p>
      </div>
      </ng-container>
    </nz-drawer>